<template>
  <div class="contract-information-page" v-loading.fullscreen.lock="fullscreenLoading">
    <Title currentPageTitle="制定终端服务计划"></Title>
    <!-- 制定终端服务计划 -->
    <div class="contract-base-box">
      <p class="contract-base-name">基础信息</p>
      <!-- 查询区域 -->
      <el-row :gutter="24">
        <el-col :span="14">
          <div class="contract-base-title"><span class="fontC-red">*</span>公司名称：</div>
          <el-select
            v-model="formData.tenantGuid"
            placeholder="请选择药企"
            class="ipt-sty"
            @change="tenantChange"
            filterable
          >
            <el-option
              v-for="item in tenantList"
              :key="item.tenantGuid"
              :label="item.tenantName"
              :value="item.tenantGuid"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="formData.organisationGuid"
            placeholder="请选择组织"
            class="ipt-sty"
            filterable
            @change="getSalesTerritory"
          >
            <el-option v-for="item in organisationList" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
          <el-date-picker
            v-model="formData.planYear"
            class="ipt-sty"
            value-format="yyyy"
            type="year"
            placeholder="请选择年度"
          >
          </el-date-picker>
          <el-col :span="4">
            <!-- <el-button size="mini" type="info" @click="getTip">搜索</el-button> -->
            <el-button size="mini" type="danger" @click="emptyData">清空</el-button>
          </el-col>
        </el-col>
      </el-row>
    </div>
    <!-- 按钮区域 -->
    <div class="back-color-fff content-main-box" :style="'height:' + contentMainHeight + 'px;'" style="padding: 0 16px">
      <div
        class="button-area"
      >
        <div style="padding-left: 0; display: flex" v-if="salesTerritoryList && salesTerritoryList.length > 0">
          <el-button icon="el-icon-plus" size="mini" type="info" class="mr10" @click="downLoadFile"
            >下载导入模板</el-button
          >
          <el-button
            icon="el-icon-plus"
            size="mini"
            type="info"
            class="ml0"
            v-if="!formData.tenantGuid || !formData.organisationGuid"
            @click="getTip()"
            >导入推广计划</el-button
          >
          <el-upload
            v-else
            class="upload-demo t-left"
            action="#"
            multiple
            :limit="1"
            accept=".xlsx,.xsl,.xls,.xlsm"
            :before-upload="beforeUpload"
            :http-request="changeFile"
            :file-list="fileList"
            :show-file-list="false"
          >
            <el-button
              size="mini"
              class="mr10"
              type="info"
              icon="el-icon-plus"
              >导入推广计划</el-button
            >
          </el-upload>
          <el-button icon="el-icon-plus" size="mini" type="info" @click="addData">手动添加</el-button>
        </div>
        <div style="padding-left: 0; display: flex" v-else>
          <el-button icon="el-icon-plus" size="mini" type="greyBg" >下载导入模板</el-button>
          <el-button  size="mini" type="greyBg" icon="el-icon-plus"  >导入推广计划</el-button>
          <el-button icon="el-icon-plus" size="mini" type="greyBg" >手动添加</el-button>
        </div>
        <div>
          <p class="total-tip">终端服务预算合计：<span>{{ getSumAmount(formData.detailList, 1) |
            numDigit }}</span>元&nbsp;&nbsp;&nbsp;所需人数合计：<span>{{ getSumAmount(formData.detailList, 2) }}</span> 人</p>
        </div>
      </div>
      
      <!-- 明细 -->
      <el-table :data="formData.detailList" tooltip-effect="light" style="width: 100%" :height="tableHeight">
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
            <!-- {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }} -->
          </template>
        </el-table-column>
        <el-table-column
          prop="salesTerritoryName"
          label="区域"
          :key="Math.random()"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="200"
        >
          <template slot-scope="scope">
            <!-- <el-select
             v-if="scope.row.salesTerritoryNameList.length<2"
              v-model="scope.row.salesTerritoryGuidList"
              placeholder="请选择"
              multiple
              collapse-tags
              collapse-tags-tooltip
              filterable
              @change="changeSalesTerritory(scope.row, scope.$index)"
            >
              <el-option v-for="item in salesTerritoryList" :key="item.value" :label="item.text" :value="item.value">
              </el-option>
            </el-select> -->
            <el-tooltip
              class="box-item"
              effect="light"
              :content="scope.row.salesTerritoryNameList.join(',')"
              placement="top-start"
            >
            <el-select
              v-model="scope.row.salesTerritoryGuidList"
              placeholder="请选择"
              multiple
              collapse-tags
              collapse-tags-tooltip
              filterable
              @change="changeSalesTerritory(scope.row, scope.$index)"
              
            >
              <el-option v-for="item in salesTerritoryList" :key="item.value" :label="item.text" :value="item.value">
              </el-option>
            </el-select>
          </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          prop="generalBudget"
          label="终端服务总预算(元)"
          show-overflow-tooltip
          header-align="center"
          align="right"
          width="130"
        >
          <template slot-scope="scope">{{ getMoneySummary(scope.row, scope.$index) | numDigit }}</template>
        </el-table-column>
        <el-table-column
          v-for="(item, index) in fieldData"
          v-if="item.type == 'num'"
          :key="index"
          :prop="item.fieldName"
          :label="item.title"
          show-overflow-tooltip
          header-align="center"
          align="right"
          width="110"
        >
          <template slot-scope="scope">
            <el-input
              :class="Number(scope.row[item.fieldName]) > scope.row.monthMaxMoney ? 'input-warning' : ''"
              v-model="scope.row[item.fieldName]"
              oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
              maxlength="12"
              placeholder="请输入"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="needPersonNum"
          label="所需人数"
          show-overflow-tooltip
          header-align="center"
          align="right"
          width="110"
        >
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.needPersonNum"
              oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/\D/g,'')"
              maxlength="12"
              placeholder="请输入"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="tenantName"
          label="终端服务内容"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="200"
        >
          <template slot-scope="scope">
            <span class="select-task" @click="templateFocus(scope.row, scope.$index)">{{
              getTaskTableShow(scope.row)
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="servicerGuid"
          label="服务商"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="200"
        >
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.servicerGuid"
              placeholder="请选择"
              filterable
              @change="getChangeServicer(scope.row, scope.$index)"
            >
              <el-option
                v-for="item in currentTenantData && currentTenantData.servicerList"
                :key="item.servicerGuid"
                :label="item.servicerName"
                :value="item.servicerGuid"
              >
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          prop="servicerGuid"
          label="合同名称"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="200"
        >
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.contractGuid"
              placeholder="请选择"
              filterable
              @change="getChangeContract(scope.row, scope.$index)"
            >
              <el-option
                v-for="item in getContractInfoList(scope.row, scope.$index)"
                :key="item.contractGuid"
                :label="item.contractName"
                :value="item.contractGuid"
              >
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          prop="monthMaxMoney"
          label="月度合作上限(元)"
          show-overflow-tooltip
          header-align="center"
          align="right"
          width="140"
        >
          <template slot-scope="scope">{{ scope.row.monthMaxMoney | numDigit }}</template>
        </el-table-column>
        <el-table-column prop="bank" width="80" label="操作" fixed="right" header-align="center" align="center">
          <template slot-scope="scope">
            <span class="txt-color" @click="delData(scope.$index)">删除</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 流程 -->
    <div style="padding-left: 16px; background: #fff; margin-top: 4px">
      <iframe v-show="iframeSh" :src="srcs" class="iframe-sty"></iframe>
    </div>
    <!-- 提交 -->
    <div class="submit-btn-box">
      <el-button type="borderBlack" size="small" @click="$router.go(-1)">取消</el-button>
      <el-button type="borderGreen" size="small" @click="saveReq(0)">保存</el-button>
      <el-button type="importNew" size="small" @click="saveReq(1)">提交申请</el-button>
    </div>
    <!-- 选择超级模板 -->
    <el-dialog
      title="选择超级模版任务"
      :visible.sync="dialogVisible"
      width="1100px"
      top="5%"
      custom-class="superTemplate-dialog"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div class="back-color-fff content-main-box"  :style="'height:' + dialogHeight + 'px;'" style="height: 90%">
        <div class="search-area">
          <el-row :gutter="24">
            <el-col :span="8"
              ><div class="search-area-div">任务名称：</div>
              <el-input v-model="superPage.taskContentName" class="ipt-sty" placeholder="请输入"></el-input>
            </el-col>
            <el-col :span="8"
              ><div class="search-area-div">系统功能：</div>
              <el-input v-model="superPage.menuName" class="ipt-sty" placeholder="请输入"></el-input>
            </el-col>
            <el-col :span="8"
              ><div class="search-area-div">市场分类：</div>
              <el-select
                filterable
                multiple
                v-model="superPage.marketingCategoryJson"
                class="ipt-sty"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in getCodeListByKey('超级模版-市场分类')"
                  :key="item.guid"
                  :label="item.text"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col class="mt10" :span="8"
              ><div class="search-area-div">分类对象：</div>
              <el-select filterable multiple v-model="superPage.staffCategoryJson" class="ipt-sty" placeholder="请选择">
                <el-option
                  v-for="item in getCodeListByKey('超级模版-分类对象')"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col class="mt10" :span="8"
              ><el-button size="mini" type="info" @click="getTaskList(1)">搜索</el-button>
              <el-button size="mini" type="danger" @click="emptySearchTable">清空</el-button></el-col
            >
          </el-row>
        </div>
        <el-table
          :data="taskList"
          stripe border
          style="width: 100%"
          heigth="600"
          ref="multipleTable"
          v-loading="tableLoading"
          tooltip-effect="light"
          @selection-change="handleSelectionChange"
          :row-key="(row) => row.guid"
          @row-click="handleClickTableRow"
          @select="onSelect"
        >
          <el-table-column type="selection" width="40" header-align="center" align="center"></el-table-column>
          <el-table-column label="序号" width="60" header-align="center" align="center">
            <template slot-scope="scope">
              {{ (superPage.pageIndex - 1) * superPage.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column
            prop="taskContentName"
            label="项目任务名称"
            show-overflow-tooltip
            header-align="center"
            align="left"
            width="110"
          >
            <template slot-scope="scope">{{ scope.row.taskContentName || '-' }}</template>
          </el-table-column>
          <el-table-column
            prop="isContractTask"
            label="合同任务"
            show-overflow-tooltip
            header-align="center"
            align="left"
            width="80"
          >
            <template slot-scope="scope">{{ scope.row.isContractTask == 'Y' ? '是' : '否' }}</template>
          </el-table-column>
          <el-table-column
            prop="staffCategoryJson"
            label="分类对象"
            show-overflow-tooltip
            header-align="center"
            align="left"
          >
            <template slot-scope="scope">{{ (JSON.parse(scope.row.staffCategoryJson)) | commonFilterNameList('超级模版-分类对象') }}</template>
          </el-table-column>
          <el-table-column
            prop="staffTaskNote"
            label="任务简述"
            show-overflow-tooltip
            header-align="center"
            align="left"
          >
            <template slot-scope="scope">{{ scope.row.staffTaskNote || '-' }}</template>
          </el-table-column>
          <el-table-column
            prop="tenantTaskPrice"
            label="药企标准价格"
            show-overflow-tooltip
            header-align="center"
            align="right"
            min-width="100"
          >
            <template slot-scope="scope"
              ><span v-if="scope.row.isContractTask == 'Y'">{{ scope.row.contractTaskPrice | numDigit }}</span>
              <span v-else>{{ scope.row.tenantTaskPrice | numDigit }}</span
              >{{ scope.row.tenantTaskPriceUnit }}</template
            >
          </el-table-column>
          <el-table-column
            prop="templateName"
            label="业务员标准价格"
            show-overflow-tooltip
            header-align="center"
            align="right"
            min-width="100"
          >
            <template slot-scope="scope">{{ scope.row.taskPrice | numDigit }} {{ scope.row.taskPriceUnit }}</template>
          </el-table-column>
          <el-table-column prop="countRule" label="结算标准" show-overflow-tooltip header-align="center" align="right">
            <template slot-scope="scope">{{ scope.row.countRule }}</template>
          </el-table-column>
          <el-table-column prop="menuName" label="系统功能" show-overflow-tooltip header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.menuName || '-' }}</template>
          </el-table-column>
          <el-table-column prop="marketingCategoryJson" label="市场分类" show-overflow-tooltip header-align="center" align="left">
            <template slot-scope="scope">{{ JSON.parse(scope.row.marketingCategoryJson) | commonFilterNameList('超级模版-市场分类') }}</template>
          </el-table-column>
        </el-table>
        
      </div>
      <el-pagination
        class="pt pb back-color-fff"
        background
        @size-change="handleSizeChangeSuper"
        @current-change="handleCurrentChangeSuper"
        :page-sizes="[10,20, 50, 100, 200]"
        :current-page="superPage.pageIndex"
        :page-size="superPage.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="superPage.totalRows"
      >
      </el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button type="borderBlack" size="small" @click="dialogVisible = false">取消</el-button>
        <el-button type="borderGreen" size="small" @click="selectTaskNext()">下一步</el-button>
      </span>
    </el-dialog>
    <!-- 选择超级模板 已选列表 -->
    <el-dialog
      title="已选列表"
      :visible.sync="dialogVisibleSelect"
      width="1100px"
      top="5%"
      custom-class="superTemplate-dialog"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div class="back-color-fff content-main-box"  :style="'height:' + checkHeight + 'px;'" style="height: 100%">
        <el-table  :data="taskSelectList" tooltip-effect="light" style="width: 100%" height="66vh">
          <el-table-column label="序号" width="60" header-align="center" align="center">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column
            prop="taskContentName"
            label="项目任务名称"
            show-overflow-tooltip
            header-align="center"
            align="left"
          >
            <template slot-scope="scope">
              <el-input
                :disabled="scope.row.isContractTask == 'Y' ? true : false"
                v-model="scope.row.taskContentName"
                maxlength="20"
                placeholder="请输入"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="isContractTask"
            label="合同任务"
            show-overflow-tooltip
            header-align="center"
            align="left"
            width="70"
          >
            <template slot-scope="scope">{{ scope.row.isContractTask == 'Y' ? '是' : '否' }}</template>
          </el-table-column>
          <el-table-column
            prop="tenantTaskPrice"
            label="药企标准价格"
            show-overflow-tooltip
            header-align="center"
            align="left"
            width="170"
          >
            <template slot-scope="scope">
              <el-input
                v-if="scope.row.isContractTask == 'Y' && scope.row.contractTaskPrice"
                style="width: 100px"
                :disabled="scope.row.isContractTask == 'Y' ? true : false"
                v-model="scope.row.contractTaskPrice"
                oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
                maxlength="12"
                placeholder="请输入"
              ></el-input>
              <el-input
                v-else
                style="width: 100px"
                :disabled="scope.row.isContractTask == 'Y' ? true : false"
                v-model="scope.row.tenantTaskPrice"
                oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
                maxlength="12"
                placeholder="请输入"
              ></el-input>
              {{ scope.row.tenantTaskPriceUnit }}
            </template>
          </el-table-column>
          <el-table-column
            prop="templateName"
            label="业务员标准价格"
            show-overflow-tooltip
            header-align="center"
            align="left"
            width="170"
          >
            <template slot-scope="scope">
              <el-input
                style="width: 100px"
                :disabled="scope.row.isContractTask == 'Y' ? true : false"
                v-model="scope.row.taskPrice"
                oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
                maxlength="12"
                placeholder="请输入"
              ></el-input>
              {{ scope.row.taskPriceUnit }}
            </template>
          </el-table-column>
          <el-table-column prop="bank" width="70" label="操作" header-align="center" align="center">
            <template slot-scope="scope">
              <span class="txt-color" @click="delTaskData(scope.$index)">删除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="borderBlack" size="small" @click="selectTaskPrev()">上一步</el-button>
        <el-button type="borderGreen" size="small" @click="selectTaskSure()">确定</el-button>
      </span>
    </el-dialog>
    <!-- 导入 -->
    <el-dialog
      title="批量导入"
      :visible.sync="showImport"
      width="800px"
      class="importClass"
      :close-on-click-modal="false"
    >
      <div class="secondStep">
        <p class="line1" v-if="importResult.error == '0'">数据导入完成，请核对！</p>
        <p class="line1" v-else>数据导入完成，请核对！</p>
        <p class="line2">
          共导入数据 <span> {{ importResult.total }} </span> 条，导入成功 <span>{{ importResult.ok }} </span> 条
          <span v-if="importResult.error > 0"
            >，失败<span> {{ importResult.error }} </span> 条。</span
          >
        </p>
        <p class="line3" @click="downFailData" v-if="importResult.error > 0">下载导入失败数据</p>
      </div>
    </el-dialog>
    <ChoosePerson ref="choosePerson" :esTenantGuid="formData.tenantGuid" staffType="1" @onSelect="onPersonSelect"></ChoosePerson>
  </div>
</template>
<script>
import { bpmnroute } from '@/api/apiRoute';
import areaJson from '../../assets/js/china_address_v4.js';
import Title from '@/components/title/title.vue';
import tableSelectCache from '@/uilt/tableSelectCache';
import ChoosePerson from './components/choosePersonOne';
import { values } from 'lodash';
export default {
  components: {
    Title,
    ChoosePerson
  },
  data() {
    return {
      personShow: false,
      contentMainHeight:window.innerHeight - 300,
      tableHeight:window.innerHeight - 400,
      dialogHeight:window.innerHeight - 360,
      checkHeight:window.innerHeight - 260,
      height: window.innerHeight - 400,
      flowType: '00014',
      fullscreenLoading: false,
      dialogVisible: false,
      dialogVisibleSelect: false,
      tenantList: [],
      organisationList: [],
      tableData: [],
      fileList: [],
      salesTerritoryList: [],
      tableLoading: false,
      currentTenantData: '',
      currentRowData: '',
      provinceList: areaJson,
      formData: {
        guid: null,
        tenantGuid: null,
        tenantName: null,
        organisationGuid: null,
        organisationName: null,
        planYear: null,
        bizApproveState: null,
        currentTenantGuid: null, //当前登录人的公司唯一标识
        isSendFlowFlag: null, //是否发起流程(Y 是 ；N 否 ； 默认为N或者空)
        detailList: [],
        startAssigner:null,
      },
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
      },
      superPage: {
        bizState:'Y',
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        isSuper: 'Y',
        contractGuid: null,
        taskContentName: null,
        menuName: null,
        staffCategoryJson: [],
        marketingCategoryJson: [],
      },
      taskList: [],
      taskSelectList: [], //选定后的任务数据
      multipleSelection: [], //选定前的任务数据
      //需验证的字段合集
      fieldData: [
        // { title: '区域', fieldName: 'salesTerritoryGuid', type: 'input' },
        { title: '区域', fieldName: 'detailTerritoryList', type: 'input' },
        { title: '1月(元)', fieldName: 'januaryBudget', type: 'num' },
        { title: '2月(元)', fieldName: 'februaryBudget', type: 'num' },
        { title: '3月(元)', fieldName: 'marchBudget', type: 'num' },
        { title: '4月(元)', fieldName: 'aprilBudget', type: 'num' },
        { title: '5月(元)', fieldName: 'mayBudget', type: 'num' },
        { title: '6月(元)', fieldName: 'juneBudget', type: 'num' },
        { title: '7月(元)', fieldName: 'julyBudget', type: 'num' },
        { title: '8月(元)', fieldName: 'augustBudget', type: 'num' },
        { title: '9月(元)', fieldName: 'septemberBudget', type: 'num' },
        { title: '10月(元)', fieldName: 'octoberBudget', type: 'num' },
        { title: '11月(元)', fieldName: 'novemberBudget', type: 'num' },
        { title: '12月(元)', fieldName: 'decemberBudget', type: 'num' },
        { title: '所需人数', fieldName: 'needPersonNum', type: 'input' },
        { title: '市场拓展手段', fieldName: 'templateDetailJson', type: 'input' },
        { title: '合同名称', fieldName: 'contractGuid', type: 'input' },
        { title: '服务商', fieldName: 'servicerGuid', type: 'input' },
      ],
      //流程
      srcs: '',
      processInstanceId: '',
      iframeSh: false,
      // 导入
      showImport: false,
      importResult: {
        total: 0,
        ok: 0,
        error: 0,
      },
      num: 0,
      currentContractGuid: null,
    };
  },
  created() {
    this.getTenantList();
    this.getFlowGuid();
    
  },
  methods: {
    getSumAmount(list, type) {
      let sum = 0;
      if (type == 1) {
          list.forEach(item => {
              // sum += item.settleAmount;
              sum += Math.round(item.generalBudget * 100) / 100 ;
          })
      }
      if (type == 2) {
          list.forEach(item => {
            sum += Math.round(item.needPersonNum * 100) / 100;
          })

      }
      return sum
    },
    //判断是否能指定最后节点的审批人
    isLastPerson(camundaDeploymentId) {
      let self = this;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/nodes/is-need-design?deploymentId=${camundaDeploymentId}`).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.personShow = res.data.data;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getTip() {
      if (!this.formData.tenantGuid) {
        this.$message.error('请先选择药企');
        return false;
      }
      if (!this.formData.organisationGuid) {
        this.$message.error('请选择组织');
        return false;
      }
      if (!this.formData.planYear) {
        this.$message.error('请选择年度');
        return false;
      }
      return true;
    },
    emptyData() {
      this.formData.tenantGuid = null;
      this.formData.organisationGuid = null;
      this.formData.planYear = null;
      this.formData.detailList = [];
    },
    //获取药企
    getTenantList() {
      let self = this;
      self.api
        .get(
          `/${serverConfig.msCustomerService}/contract/get-select-contract-tenant`,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tenantList = res.data.data || [];
            if (this.$route.query.guid) {
              this.getPageDetail();
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    tenantChange(val) {
      if (val) {
        this.currentTenantData = this.tenantList.filter((k) => {
          return k.tenantGuid == val;
        })[0];
        this.formData.tenantName = this.currentTenantData.tenantName;
        this.formData.detailList = [];
        this.formData.organisationGuid = null;
        this.formData.planYear = null;
        this.getOrganisationList(val);
      }
    },
    //获取组织
    getOrganisationList(v) {
      let self = this;
      self.api
        .get(`/${serverConfig.msPersonnelService}/organisation/get-organisation-dict?tenantGuid=${v}`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.organisationList = res.data.data || [];
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //区域验重
    changeSalesTerritory(row, index) {
      let list=[]
      this.formData.detailList.forEach(item=>{
        let arr=item.salesTerritoryGuidList||[]
        list=list.concat(arr)
      })
      var mapArr = list.map(item => item);
      var setArr = new Set(mapArr);//去重
      if ( setArr.size< mapArr.length ) {
        this.$message.error('列表已存在该区域，请重新选择');
        this.formData.detailList[index].salesTerritoryGuidList.pop();
      }
      console.log(setArr.size< mapArr.length ? '有重复' : '无重复');

      if (this.formData.detailList[index].salesTerritoryGuidList&&this.formData.detailList[index].salesTerritoryGuidList.length>0) {
        this.formData.detailList[index].salesTerritoryNameList=[]
        this.formData.detailList[index].detailTerritoryList=[]
        this.formData.detailList[index].salesTerritoryGuidList.forEach(guid=>{
          this.salesTerritoryList.forEach((i) => {
            if (i.value == guid) {
              let obj={
                salesTerritoryGuid: guid,
                salesTerritoryName: i.text
              }
              this.formData.detailList[index].detailTerritoryList.push(obj);
              this.formData.detailList[index].salesTerritoryNameList.push(i.text);
            }
          });
        })
        
      }
      // this.formData.detailList[index].salesTerritoryGuidList
      this.$set(this.formData.detailList,this.formData.detailList)
      // this.$set(this.formData,this.formData)
      console.log('---',row.salesTerritoryGuidList,this.formData.detailList[index].detailTerritoryList,this.formData.detailList[index].salesTerritoryGuidList,this.formData.detailList[index].salesTerritoryNameList);
      this.$nextTick(()=>{
        this.$forceUpdate()
      })
      // for (let i = 0; i < this.formData.detailList.length; i++) {
      //   for (let j = i + 1; j < this.formData.detailList.length; j++) {
      //     this.formData.detailList[i].salesTerritoryGuidList
      //     // this.formData.detailList[i].salesTerritoryGuid &&
      //     //   this.formData.detailList[i].salesTerritoryGuid == this.formData.detailList[j].salesTerritoryGuid
          
      //     if (
      //       this.formData.detailList[i].salesTerritoryGuidList.length>0 &&
      //       this.formData.detailList[i].salesTerritoryGuid == this.formData.detailList[j].salesTerritoryGuid
      //     ) {
      //       this.$message.error('列表已存在该区域，请重新选择');
      //       this.formData.detailList[index].salesTerritoryGuid = null;
      //     }
      //   }
      // }
      // if (row.salesTerritoryGuid) {
      //   this.salesTerritoryList.forEach((i) => {
      //     if (i.value == row.salesTerritoryGuid) {
      //       this.formData.detailList[index].salesTerritoryName = i.text;
      //     }
      //   });
      // }
    },
    //获取组织的销售区域
    getSalesTerritory(val) {
      let self = this;
      if (!self.formData.organisationGuid) {
        return;
      }
      if (self.organisationList && self.organisationList.length > 0) {
        self.organisationList.forEach((i) => {
          if (i.value == self.formData.organisationGuid) {
            self.formData.organisationName = i.text;
          }
        });
      }
      if (self.formData.detailList && self.formData.detailList.length > 0) {
        self.formData.detailList.forEach((m) => {
          m.salesTerritoryGuid = null;
        });
      }
      let tenantGuid = self.$route.query.tenantGuid;
      let promise = {
        tenantGuid: self.formData.tenantGuid,
        organisationGuids: [self.formData.organisationGuid],
        pageIndex: 1,
        pageSize: -1,
      };
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/sales-territory/get-select-sales-territory`, promise)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (res.data.data && res.data.data.length > 0) {
              self.salesTerritoryList = res.data.data;
            } else {
              self.salesTerritoryList = [];
              self.$message.error('请先维护该企业部门的销售区域');
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    getChangeServicer(row, index) {
      if (this.currentTenantData.servicerList && this.currentTenantData.servicerList.length > 0) {
        this.currentTenantData.servicerList.forEach((i) => {
          if (row.servicerGuid == i.servicerGuid) {
            this.formData.detailList[index].servicerName = i.servicerName;
            this.formData.detailList[index].monthMaxMoney = i.monthMaxMoney;
            this.formData.detailList[index].templateDetailJson =  i.contractInfoList ? i.contractInfoList[0].templateDetailList : [];
            this.formData.detailList[index].contractGuid = i.contractInfoList ? i.contractInfoList[0].contractGuid : null;
            this.formData.detailList[index].contractName = i.contractInfoList ? i.contractInfoList[0].contractName : null;
            this.getTaskTableShow(row)
          }
        });
      }
    },
    //获取合同下拉
    getContractInfoList(row, index){
      let arr = [];
      if (this.currentTenantData.servicerList && this.currentTenantData.servicerList.length > 0) {
        this.currentTenantData.servicerList.forEach((i) => {
          if (row.servicerGuid == i.servicerGuid) {
            arr = i.contractInfoList || [];
          }
        });
      }
      return arr
    },
    getChangeContract(row, index){
      if (this.currentTenantData.servicerList && this.currentTenantData.servicerList.length > 0) {
        this.currentTenantData.servicerList.forEach((i) => {
          if (row.servicerGuid == i.servicerGuid && i.contractInfoList && i.contractInfoList.length > 0) {
            i.contractInfoList.forEach(j=>{
              if(this.formData.detailList[index].contractGuid == j.contractGuid){
                this.formData.detailList[index].contractName = j.contractName;
                this.formData.detailList[index].templateDetailJson =  j.templateDetailList || [];
                this.getTaskTableShow(row)
              }
            })
          }
        });
      }
    },
    // 金额汇总
    getMoneySummary(row, index) {
      let money = 0;
      this.fieldData.forEach((i) => {
        for (let j in row) {
          if (i.fieldName == j && i.type == 'num') {
            money = money + Number(row[j]);
          }
        }
      });
      this.formData.detailList[index].generalBudget = money;
      return money;
    },
    //打开超级模板弹框
    templateFocus(row, index) {
      if (!row.servicerGuid) {
        this.$message.error('请先选择服务商');
        return;
      }
      if (!row.contractGuid) {
        this.$message.error('请先选择合同');
        return;
      }
      this.currentRowData = row;
      row.index = index;
      //默认选中药企下面的服务商的合同下面的模板
      // if (this.currentTenantData.servicerList && this.currentTenantData.servicerList.length > 0) {
      //   this.currentTenantData.servicerList.forEach((i) => {
      //     if (row.servicerGuid == i.servicerGuid && i.contractInfoList && i.contractInfoList.length > 0) {
      //       i.contractInfoList.forEach(j=>{
      //         if(row.contractGuid == j.contractGuid){
      //           this.taskSelectList = row.templateDetailList || [];
      //         }
      //       })
      //     }
      //   });
      // }
      this.taskSelectList = row.templateDetailJson || []
      this.superPage.contractGuid = this.formData.detailList[index].contractGuid;
      this.emptySearchTable(1);
      this.getTaskList(1,row);
      // this.multipleSelection = this.taskSelectList;
      // if (this.currentTenantData.servicerList && this.currentTenantData.servicerList.length > 0) {
      //   this.currentTenantData.servicerList.forEach((i) => {
      //     if (row.servicerGuid == i.servicerGuid) {
      //       this.superPage.contractGuid = i.contractGuid;
      //       this.getTaskList(1);
      //     }
      //   });
      // }
      this.dialogVisible = true;
    },
    //获取任务超级模板 type为1 重置第一页 
    getTaskList(type,row) {
      let self = this;
      if (type == 1) {
        this.superPage.pageIndex = 1;
      }
      let req=this.superPage
      req.taskContentName=!req.taskContentName ? null : Array.isArray(req.taskContentName) ? req.taskContentName : [req.taskContentName]
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/template/detail/get-detail-page-list`, req)
        .then((res) => {
          self.tableLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.taskList = res.data.data?res.data.data.records : [];
            console.log('first', self.taskSelectList);
            // self.multipleSelection = [];
            // self.$refs.multipleTable.clearSelection();
            if (self.taskList && self.taskList.length > 0) {
              self.$nextTick(() => {
                self.taskList.forEach((i) => {
                  self.taskSelectList.forEach((j) => {
                    if (i.guid == j.guid) {
                      self.$refs.multipleTable.toggleRowSelection(i, true);//勾选已选列表的数据
                      // self.multipleSelection.push(i);
                    }
                  });
                });
              });
            }
            self.superPage.totalRows = res.data.data?res.data.data.totalRows:0;
            self.superPage.totalPage = res.data.data?res.data.data.totalPages:0;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //清空查询
    emptySearchTable(type) {
      this.superPage = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        isSuper: 'Y',
        contractGuid: this.superPage.contractGuid,
        taskContentName: null,
        menuName: null,
        staffCategoryJson: [],
        marketingCategoryJson: [],
      };
      if (type !== 1) {
        this.getTaskList();
      }
    },
    // 显示表格选中任务数量展示 任务1 + n
    getTaskTableShow(row) {
      let name = '点击选择';
      let list = row.templateDetailJson;
      if (list && list.length == 1) {
        name = list[0].taskContentName;
      }
      if (list && list.length > 1) {
        name = list[0].taskContentName + '+' + (list.length - 1);
      }
      return name;
    },
    selectTaskPrev() {
      this.getTaskList();
      this.dialogVisible = true;
      this.dialogVisibleSelect = false;
    },
    selectTaskNext() {
      if (!this.taskSelectList.length) {
        this.$message.error('请选择任务！');
        return;
      }
      this.dialogVisible = false;
      this.dialogVisibleSelect = true;
      // this.$refs.multipleTable.clearSelection();
      this.multipleSelection = this.taskSelectList;
      console.log('first1', this.taskSelectList);
    },
    // 确定提交弹框所选任务
    selectTaskSure() {
      if (!this.taskSelectList.length) {
        this.$message.error('请选择任务！');
        return;
      }
      let arr = [];
      this.taskSelectList.forEach((i) => {
        let obj = {
          guid: i.guid,
          taskContentName: i.taskContentName,
          taskPrice: Number(i.taskPrice),
          taskPriceUnit: i.taskPriceUnit,
          tenantTaskPrice:
            i.isContractTask == 'Y' && i.contractTaskPrice ? Number(i.contractTaskPrice) : Number(i.tenantTaskPrice),//是合同任务则取合同价格，否则取药企价格
          tenantTaskPriceUnit: i.tenantTaskPriceUnit,
          isContractTask: i.isContractTask,
        };
        arr.push(obj);
      });
      this.formData.detailList[this.currentRowData.index].templateDetailJson = arr;
      this.dialogVisibleSelect = false;
    },
    //任务勾选
    handleSelectionChange(val) {
      // console.log('勾选',val)
      let self = this;
      self.multipleSelection = val;
      setTimeout(() => {
        this.taskSelectList = tableSelectCache.compare(this.taskList, this.multipleSelection, this.taskSelectList);
      }, 0);
    },
    //点击行选中
    handleClickTableRow(row, event, column) {
      this.$refs.multipleTable.toggleRowSelection(row);
    },
    //当前行是否选中
    onSelect(rows, row) {
      let selected = rows.length && rows.indexOf(row) !== -1;
      console.log('勾选', this.multipleSelection);
    },
    handleSizeChangeSuper(val) {
      let self = this;
      self.superPage.pageSize = val;
      self.superPage.pageIndex = 1;
      this.getTaskList();
    },
    handleCurrentChangeSuper(val) {
      let self = this;
      self.superPage.pageIndex = val;
      this.getTaskList();
    },
    //获取详情
    getPageDetail() {
      let self = this;
      self.api
        .get(`/${serverConfig.msSalesPerformService}/marketing-plan/detail?marketingPlanGuid=${this.$route.query.guid}`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let data = res.data.data;
            self.formData = {
              guid: data.guid,
              tenantGuid: data.tenantGuid,
              tenantName: data.tenantName,
              organisationGuid: data.organisationGuid,
              organisationName: data.organisationName,
              planYear: data.planYear,
              bizApproveState: data.bizApproveState,
              currentTenantGuid: null, //当前登录人的公司唯一标识
              isSendFlowFlag: 'N', //是否发起流程(Y 是 ；N 否 ； 默认为N或者空)
              detailList: [],
            };
            self.getOrganisationList(data.tenantGuid);
            self.getSalesTerritory();
            self.currentTenantData = self.tenantList.filter((k) => {
              return k.tenantGuid == self.formData.tenantGuid;
            })[0];
            if (data.marketingPlanDetailList) {
              self.formData.detailList = data.marketingPlanDetailList||[];
              self.formData.detailList.forEach((obj) => {
                if(obj.detailTerritoryList&&obj.detailTerritoryList.length>0){
                  obj.salesTerritoryGuidList=obj.detailTerritoryList.map((k)=>{
                    return k.salesTerritoryGuid;
                  });
                  obj.salesTerritoryNameList=obj.detailTerritoryList.map((k)=>{
                    return k.salesTerritoryName;
                  });
                }else{
                  obj.salesTerritoryGuidList=[]
                  obj.salesTerritoryNameList=[]
                }
              });
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //单行添加
    addData() {
      if (!this.formData.tenantGuid) {
        this.$message.error('请先选择药企');
        return;
      }
      if (!this.formData.organisationGuid) {
        this.$message.error('请选择组织');
        return;
      }
      if (!this.formData.planYear) {
        this.$message.error('请选择年度');
        return;
      }
      if (!this.salesTerritoryList.length) {
        this.$message.error('请先维护该企业部门的销售区域');
        return;
      }
      console.log('.detailList',this.formData,this.formData.detailList);
      
      if (this.formData.detailList && this.formData.detailList.length >= this.salesTerritoryList.length) {
        this.$message.error('数据条数不能超过销售区域总数');
        return;
      }
      try {
        if (this.formData.detailList && this.formData.detailList.length > 0) {
          this.formData.detailList.forEach((item) => {
            this.fieldData.forEach((field) => {
              console.log('pop',item[field.fieldName]);
              if (field.fieldName !== 'templateDetailJson' &&field.fieldName !== 'detailTerritoryList' && item[field.fieldName]!=0 && !item[field.fieldName]) {
                throw new Error(`以上信息中${field.title}不能为空`);
              }
              if ((field.fieldName == 'templateDetailJson'||field.fieldName == 'detailTerritoryList') &&(!item[field.fieldName]|| !item[field.fieldName].length)) {
                throw new Error(`以上信息中${field.title}不能为空`);
              }
              
            });
          });
        }
      } catch (e) {
        this.$message.error(e.message);
        return;
      }
      let obj = {
        guid: null,
        // salesTerritoryGuid: null,
        // salesTerritoryName: null,
        salesTerritoryGuidList: [],
        salesTerritoryNameList: [],
        generalBudget: null,
        januaryBudget: null,
        februaryBudget: null,
        marchBudget: null,
        aprilBudget: null,
        mayBudget: null,
        juneBudget: null,
        julyBudget: null,
        augustBudget: null,
        septemberBudget: null,
        octoberBudget: null,
        novemberBudget: null,
        decemberBudget: null,
        needPersonNum: null,
        templateDetailGuidList: [],
        templateDetailJson: [],
        servicerGuid: null,
        servicerName: null,
      };
      this.formData.detailList.push(obj);
      let index = this.formData.detailList.length;
      let servicerData = this.currentTenantData.servicerList[0];//默认选的服务商
      this.formData.detailList[index - 1].servicerGuid = servicerData.servicerGuid;
      this.formData.detailList[index - 1].servicerName = servicerData.servicerName;
      this.formData.detailList[index - 1].monthMaxMoney = servicerData.monthMaxMoney;
      this.formData.detailList[index - 1].contractGuid = servicerData.contractInfoList ? servicerData.contractInfoList[0].contractGuid : null;
      this.formData.detailList[index - 1].contractName = servicerData.contractInfoList ? servicerData.contractInfoList[0].contractName : null;
      this.formData.detailList[index - 1].templateDetailJson = servicerData.contractInfoList ? servicerData.contractInfoList[0].templateDetailList : [];
      // this.formData.detailList[index - 1].templateDetailJson =
      //   this.currentTenantData.servicerList[0].templateDetailList ;

      // this.getChangeServicer(this.formData.detailList[index],index-1);
    },
    // 删除
    delData(index) {
      this.$confirm(messageConfig.DELETE_AFTER, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.formData.detailList.splice(index, 1);
      });
    },
    delTaskData(index) {
      this.$confirm(messageConfig.DELETE_AFTER, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.taskSelectList.splice(index, 1);
      });
    },
    onPersonSelect([personGuid, data]) {
      this.formData.startAssigner = personGuid.join(',');
      if (!this.formData.startAssigner) {
        this.$message.error('请先选择人员!')
        return;
      }
      this.submitData(1);
    },
    //提交申请 type为1时保存否则提交
    saveReq(type) {
      if (!this.getTip()) {
        return;
      }
      if (type == 1) {
        let flg = false;
        try {
          if (this.formData.detailList && this.formData.detailList.length > 0) {
            this.formData.detailList.forEach((item) => {
              this.fieldData.forEach((field) => {
                console.log('pp',item[field.fieldName]);
                
                if (field.fieldName !== 'templateDetailJson' && field.fieldName !== 'detailTerritoryList' && item[field.fieldName]!=0 && !item[field.fieldName]) {
                  throw new Error(`以上信息中${field.title}不能为空`);
                }
                if ((field.fieldName == 'templateDetailJson' || field.fieldName == 'detailTerritoryList') && (!item[field.fieldName] || !item[field.fieldName].length)) {
                  throw new Error(`以上信息中${field.title}不能为空`);
                }
                if (field.type == 'num' && item[field.fieldName] > item.monthMaxMoney) {
                  flg = true;
                }
              });
            });
          }
        } catch (e) {
          this.$message.error(e.message);
          return;
        }
        if (flg) {
          this.$confirm('存在月度预算已超出服务商月度合作上限的情况，确定提交吗?', '确定提交吗', {
            confirmButtonText: '提交',
            cancelButtonText: '暂不提交',
            type: 'warning',
          })
            .then(() => {
              this.submitData(type);
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消操作',
              });
              return;
            });
        } else {
          if (this.personShow == true && !this.formData.startAssigner) {
            this.$refs.choosePerson.visible = true;
          } else {
            this.submitData(type);
          }
       
        }
      } else {
        this.submitData(type);
      }
    },
    //最终提交
    submitData(type) {
      let userinfo = JSON.parse(localStorage.userInfo);
      let form = this.formData;
      //登录人信息
      form.staffGuid = userinfo.staffGuid;
      form.staffName = userinfo.staffName;
      form.currentTenantGuid = localStorage.guid;
      let reqUrl;
      //是否发起审批
      form.isSendFlowFlag = type == 1 ? 'Y' : 'N';
      //重新提交
      if (this.$route.query.toType == 3) {
        form.bizApproveState = 'D';
      }
      if (this.formData.guid) {
        reqUrl = `/marketing-plan/update`;
      } else {
        reqUrl = `/marketing-plan/add`;
      }
      this.fullscreenLoading = true;
      this.api
        .postJson(`/${serverConfig.msSalesPerformService}${reqUrl}`, form)
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message({
              message: messageConfig.SUBMIT_SUCCESS,
              type: 'success',
            });
            this.$router.go(-1);
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(() => {
          this.fullscreenLoading = false;
        });
    },
    //下载模板
    downLoadFile() {
      window.open('/市场推广计划导入模板.xlsx');
    },
    //上传文件
    changeFile(file, fileList) {
      let self = this;
      self.fileList = [];
      self.fullscreenLoading = true;
      let formData = new FormData();
      formData.append('file', file.file); //传文件
      let importUrl = `/${serverConfig.msSalesPerformService}/marketing-plan/import-marketing-plan?tenantGuid=${self.formData.tenantGuid}&organisationGuid=${self.formData.organisationGuid}`;
      self.api.postFile(importUrl, formData).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let oldList = JSON.parse(JSON.stringify(self.formData.detailList)); //原数组
          let newList = res.data.data; //新数组
          // let totalList = [...oldList, ...newList];
          let totalList = [ ...newList];//不用覆盖了
          // let newArr = [];
          // if (totalList && totalList.length > 0) {
          //   //如果导入的数据中列表已存在，则覆盖已有数据
          //   totalList.forEach((k) => {
          //     const index = newArr.findIndex((m) => m.salesTerritoryGuid === k.salesTerritoryGuid);
          //     if (index > -1) {
          //       newArr[index] = Object.assign({}, newArr[index], k);
          //     } else {
          //       newArr.push(k);
          //     }
          //   });
          // }
          // self.formData.detailList = newArr;
          if (totalList && totalList.length > 0){
            totalList.forEach((obj,idx) => {
              if(!obj.contractGuid)obj.contractGuid=''
              //导入获得数据之后，默认带出合同contractGuid，及最新合同的任务templateDetailJson，但是要手动触发合同的change事件
          //   getChangeContract(scope.row, scope.$index)
              if(obj.contractInfo){
                obj.contractGuid = obj.contractInfo.contractGuid
                obj.contractName = obj.contractInfo.contractName;
                obj.templateDetailJson =  obj.contractInfo.templateDetailList || [];
                this.getTaskTableShow(obj)
              }
              if(obj.detailTerritoryList&&obj.detailTerritoryList.length>0){
                obj.salesTerritoryGuidList=obj.detailTerritoryList.map((k)=>{
                  return k.salesTerritoryGuid;
                });
                obj.salesTerritoryNameList=obj.detailTerritoryList.map((k)=>{
                  return k.salesTerritoryName;
                });
              }else{
                obj.salesTerritoryGuidList=[]
                obj.salesTerritoryNameList=[]
              }
            });
          }
         
          
          self.formData.detailList = totalList;
          
          let msg = res.data.msg.split(',');
          self.importResult = {
            total: msg[0],
            ok: msg[1],
            error: msg[2],
          };
          self.showImport = true;
        } else {
          self.$message({
            type: 'warning',
            message: res.data.msg,
          });
          return false;
        }
      });
    },
    //批量导入文件限制
    beforeUpload(file) {
      let filename = file.name;
      let arr = filename.split('.');
      if (arr[1] !== 'xls' && arr[1] !== 'xlsx' && arr[1] !== 'xlsm') {
        this.$message.error('上传文件只能是 excel/xls 格式!');
        return false;
      }
      return arr;
    },
    //下载失败数据
    downFailData() {
      let self = this;
      self.api
        .postJsonD(
          `/${serverConfig.msSalesPerformService}/marketing-plan/export-error-data?tenantGuid=${this.formData.tenantGuid}&organisationGuid=${this.formData.organisationGuid}`,
        )
        .then((res) => {
          if (res.data) {
            let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            let fileName = '市场推广计划';
            let objectUrl = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.download = fileName;
            link.href = objectUrl;
            link.click();
          } else {
            self.$message.error(res.msg || '下载失败，请联系管理员！');
          }
        });
    },
    //获取流程Guid
    getFlowGuid() {
      let self = this;
      let userInfo = JSON.parse(localStorage.userInfo);
      let req = {
        tenantGuid: localStorage.guid,
        flowType: this.flowType,
        staffGuid: userInfo.staffGuid,
      };
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/get-camunda-deployment-id`, req)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (res.data.data) {
              self.iframeSh = true;
              this.isLastPerson(res.data.data);
              self.srcs =
                bpmnroute + '/iframeBpmn?camundaDeploymentId=' + res.data.data + '&token=' + localStorage.token;
              console.log(self.srcs);
            } else {
              self.$message.error(messageConfig.FLOW_NO_ID);
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getList();
    },
  },
};
</script>
<style scoped>
.contract-information-page {
  overflow: auto;
}
.contract-base-box {
  padding: 10px 16px 0px 16px;
  margin-top: 4px;
  background: #fff;
}
.contract-base-name {
  font-size: 16px;
  color: #212121;
  text-align: left;
  margin: 8px 0 10px 0;
}
.contract-base-box .el-col-14,
.contract-base-box .el-col-4 {
  min-height: 37px;
  display: flex;
  /* align-items: center; */
  /* margin-bottom: 16px; */
  padding-right: 20px;
  box-sizing: border-box;
}
.contract-base-title {
  flex-shrink: 0;
  width: 100px;
  line-height: 36px;
  text-align: right;
  font-size: 14px;
}
.contract-base-content {
  width: 314px;
  text-align: left;
  line-height: 36px;
}
/deep/.el-radio-group {
  padding-top: 5px !important;
}
/* 流程 */
.iframe-sty {
  width: 100%;
  height: 500px;
  border: none;
  /* background:grey; */
}
.submit-btn-box {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  border-top: 1px solid #d9d9d9;
  background: #fff;
}
/* 导入 */
.importClass .secondStep {
  margin-top: 50px;
  height: 200px;
}

.importClass .secondStep .line1 {
  font-size: 20px;
}

.importClass .secondStep .line2 {
  font-size: 16px;
}

.importClass .secondStep .line2 span {
  color: #4fa1a4;
}

.importClass .secondStep .line3 {
  text-decoration: underline;
  cursor: pointer;
}
.ipt-sty {
  margin-right: 10px;
}
/deep/ .el-input__prefix {
  top: -8px;
}
.content-main-box /deep/ .el-input__inner {
  height: 30px;
  line-height: 30px;
}
.el-col-8 {
  display: flex;
  justify-content: flex-start;
}
.input-warning /deep/ .el-input__inner {
  border: 1px solid red;
}
.select-task {
  color: #4fa1a4;
  text-decoration: underline;
  cursor: pointer;
}
.button-area{
  padding-left: 0;
  display: flex;
  justify-content:space-between;
  align-items: center
}
.total-tip {
  text-align: right;
  /* margin: 0 0 16px 0; */
}

.total-tip span {
  color: #FF5F1F;
}
</style>
<style>
.superTemplate-dialog .el-dialog__body{
  padding: 10px 20px 0;
}


</style>